import * as zod from "zod"

export class URLValidator {
  private static schema = zod.string().url()

  public static validate(url: string): boolean {
    const normalizedUrl = url.toLowerCase().trim()
    return this.schema.safeParse(normalizedUrl).success
  }
}

/**
 * Whether a URL is safe to use as an `href`.
 *
 * `URLValidator.validate` is NOT this check — it is `zod.string().url()`, which
 * only asks whether the string parses as a URL. It returns true for
 * `javascript:alert(1)` and `data:text/html,...`, either of which executes in
 * this origin when rendered as a link and clicked. Use this whenever the URL
 * came from outside the app (API responses, ad-platform data, user input).
 */
export function isSafeHttpUrl(url: string): boolean {
  return /^https?:\/\//i.test(url.trim())
}
